const assets = {
	ff_list: () => import('./ff_list/ff_list.scss'),
	ff_usps: () => import('./ff_usps/ff_usps.scss'),
	ff_plumbing: () => import('./ff_plumbing/ff_plumbing.scss'),

	// sample: () => import('./sample/sample'),
	// images_accordion: () => import('./images_accordion/init'),
	// before_after_slider: () => import('./before_after_slider/init'),
	// marquee: () => import('./marquee/init'),
};

if (ff_elementor_asset_loader) {
	ff_elementor_asset_loader.load = load_asset;
	ff_elementor_asset_loader.queue.forEach(load_asset);
}

function load_asset(key) {
	if (assets[key]) assets[key]();
}
